export default Object.freeze({
  MENU_MAIN: 'header_main',
  MENU_TOP: 'header_top',
  MENU_HELP: 'header_help',
  MENU_FOOTER: 'footer_main',
});
